import EmptyPage from '../utility_objects/EmptyPage';

function LoginMSALInitError() {
  return <EmptyPage />;
}

export default LoginMSALInitError;
